import VueCookie from "vue-cookie";

export default {
    id: '',
    displayName: '',
    firstname: '',
    lastname: '',
    avatar: '',
    email: '',
    signature: '',
    caps: [],
    hasOrders: false,
    hasRecurringSubscriptions: false,
    hasLimitedSubscriptions: false,
    isAuth() {
        if (this.email !== '' && this.signature !== '' && this.id !== '') {
            return true
        } else {
            this.id = VueCookie.get('AuthUserId')
            this.email = VueCookie.get('AuthUserEmail')
            this.signature = VueCookie.get('AuthUserSignature')

            if (!Core.Validation.isId(this.id)) {
                this.id = ''
                this.email = ''
                this.signature = ''
            }

            if (this.email !== '' && this.signature !== '') {
                return true
            }
        }
        return false
    },
    retrieve() {
        this.id = VueCookie.get('AuthUserId')
        this.email = VueCookie.get('AuthUserEmail')
        this.signature = VueCookie.get('AuthUserSignature')

        if (!Core.Validation.isId(this.id)) {
            this.id = ''
            this.email = ''
            this.signature = ''
        }
    },
    can(caps) {
        if (!Array.isArray(caps)) {
            caps = [caps]
        }
        for(let cap in caps) {
            cap = caps[cap]
            for(let userCap in this.caps) {
                userCap = this.caps[userCap]
                if (userCap===cap) {
                    return true
                }
            }
        }
        return false
    },
    reset() {
        this.id = ''
        this.email = ''
        this.signature = ''
    },
    setCookies() {
        VueCookie.set('AuthUserId', this.id, 99)
        VueCookie.set('AuthUserEmail', this.email, 99)
        VueCookie.set('AuthUserSignature', this.signature, 99)
    }
}